/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Needs_ThreadInputs */



/**
* | output |
* | --- |
* | "Put this meeting in a conversation above, and Wundo can prepare it." |
*
* @param {Meeting_Prep_Needs_ThreadInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_needs_thread = /** @type {((inputs?: Meeting_Prep_Needs_ThreadInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Needs_ThreadInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppel deze afspraak eerst aan een gesprek hierboven, dan kan Wundo je voorbereiden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reliez d'abord cette réunion à une conversation ci-dessus, et Wundo pourra vous aider à vous préparer.")
	return /** @type {LocalizedString} */ ("Put this meeting in a conversation above, and Wundo can prepare it.")
});